import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { studentsGet } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getStudents = createAsyncThunk(
    'getStudents/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await studentsGet(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_GQ_ADMIN_STUDENTS_FETCH_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const getStudentsSlice = createSlice({
    name: 'getStudents',
    initialState,
    extraReducers: {
        [getStudents.pending]: (state) => {
            state.loading = true;
        },
        [getStudents.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [getStudents.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const getStudentsSelector = (state) => state.getStudents;
export const getStudentsReducer = getStudentsSlice.reducer;
